module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2d823ff2.png";